import React, { useEffect, useRef, useState } from "react";

const IframeComponent = ({ div }) => {
  const divisionRef = useRef(null);
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);

  const generateKeyframes = () => {
    if (!div.keyframes || div.keyframes.length === 0) return null;

    return div.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };
  useEffect(() => {
    if (divisionRef.current && div.keyframes && div.keyframes.length > 0) {
      const keyframes = generateKeyframes();
      const animation = divisionRef.current.animate(keyframes, {
        duration: parseFloat(div.animationDuration) * 1000 || 1000,
        delay: parseFloat(div.animationDelay) * 1000 || 0,
        iterations:
          div.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(div.animationIterationCount) || 1,
        direction: div.animationDirection || "normal",
        fill: div.animationFillMode || "none",
        easing: div.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    div.keyframes,
    div.animationDuration,
    div.animationDelay,
    div.animationIterationCount,
    div.animationDirection,
    div.animationFillMode,
    div.animationTimingFunction,
  ]);

  const focusedStyles =
    isDivFocused && div.pseudoClass === "focus"
      ? {
          width: div.focusedwidth || div.width || "20%",
          height: div.focusedheight || div.height || "30%",

          padding: div.focusedpadding || div.padding || "0",
          paddingTop: div.focusedpaddingTop || div.focusedpadding || "0",
          paddingRight: div.focusedpaddingRight || div.focusedpadding || "0",
          paddingBottom: div.focusedpaddingBottom || div.focusedpadding || "0",
          paddingLeft: div.focusedpaddingLeft || div.focusedpadding || "0",
          margin: div.focusedmargin || div.margin || "0px",
          marginTop: div.focusedmarginTop || div.focusedmargin || "0px",
          marginRight: div.focusedmarginRight || div.focusedmargin || "0px",
          marginBottom: div.focusedmarginBottom || div.focusedmargin || "0px",
          marginLeft: div.focusedmarginLeft || div.focusedmargin || "0px",

          borderTop:
            div.focusedborderTop || div.focusedborder || div.border || "none",
          borderRight:
            div.focusedborderRight || div.focusedborder || div.border || "none",
          borderBottom:
            div.focusedborderBottom ||
            div.focusedborder ||
            div.border ||
            "none",
          borderLeft:
            div.focusedborderLeft || div.focusedborder || div.border || "none",
          borderSapcing: div.focusedborderSpacing || div.borderSpacing || "0px",
          borderCollapse:
            div.focusedborderCollapse || div.borderCollapse || "0px",
          borderRadius: div.focusedborderRadius || div.borderRadius || "0",
          outline: div.focusedoutline || div.outline || "none",

          position: div.focusedposition || div.position || "relative",
          top: div.focusedtop || div.top || "auto",
          right: div.focusedright || div.right || "auto",
          bottom: div.focusedbottom || div.bottom || "auto",
          left: div.focusedleft || div.left || "auto",
          zIndex: div.focusedzIndex || div.zIndex || "auto",

          boxShadow: div.focusedboxShadow || div.boxShadow || "none",
          opacity: div.focusedOpacity || div.opacity || 1,
          cursor: div.focusedcursor || div.cursor || "default",
          visibility: div.focusedvisibility || "visible",
        }
      : {};

  const hoverStyles =
    isDivHovered && div.pseudoClass === "hover"
      ? {
          width: div.hoveredwidth || div.width || "20%",
          height: div.hoveredheight || div.height || "30%",

          padding: div.hoveredpadding || div.padding || "0",
          paddingTop: div.hoveredpaddingTop || div.hoveredpadding || "0",
          paddingRight: div.hoveredpaddingRight || div.hoveredpadding || "0",
          paddingBottom: div.hoveredpaddingBottom || div.hoveredpadding || "0",
          paddingLeft: div.hoveredpaddingLeft || div.hoveredpadding || "0",
          margin: div.hoveredmargin || div.margin || "0px",
          marginTop: div.hoveredmarginTop || div.hoveredmargin || "0px",
          marginRight: div.hoveredmarginRight || div.hoveredmargin || "0px",
          marginBottom: div.hoveredmarginBottom || div.hoveredmargin || "0px",
          marginLeft: div.hoveredmarginLeft || div.hoveredmargin || "0px",

          borderTop:
            div.hoveredborderTop || div.hoveredborder || div.border || "none",
          borderRight:
            div.hoveredborderRight || div.hoveredborder || div.border || "none",
          borderBottom:
            div.hoveredborderBottom ||
            div.hoveredborder ||
            div.border ||
            "none",
          borderLeft:
            div.hoveredborderLeft || div.hoveredborder || div.border || "none",
          borderSapcing: div.hoveredborderSpacing || div.borderSpacing || "0px",
          borderCollapse:
            div.hoveredborderCollapse || div.borderCollapse || "0px",
          borderRadius: div.hoveredborderRadius || div.borderRadius || "0",
          outline: div.hoveredoutline || div.outline || "none",

          position: div.hoveredposition || div.position || "relative",
          top: div.hoveredtop || div.top || "auto",
          right: div.hoveredright || div.right || "auto",
          bottom: div.hoveredbottom || div.bottom || "auto",
          left: div.hoveredleft || div.left || "auto",
          zIndex: div.hoveredzIndex || div.zIndex || "auto",

          boxShadow: div.hoveredboxShadow || div.boxShadow || "none",
          opacity: div.hoveredOpacity || div.opacity || 1,
          cursor: div.hoveredcursor || div.cursor || "default",
          visibility: div.hoveredvisibility || "visible",
        }
      : {};

  const activeStyles =
    isDivActive && div.pseudoClass === "active"
      ? {
          width: div.activatedwidth || div.width || "20%",
          height: div.activatedheight || div.height || "30%",

          padding: div.activatedpadding || div.padding || "0",
          paddingTop: div.activatedpaddingTop || div.activatedpadding || "0",
          paddingRight:
            div.activatedpaddingRight || div.activatedpadding || "0",
          paddingBottom:
            div.activatedpaddingBottom || div.activatedpadding || "0",
          paddingLeft: div.activatedpaddingLeft || div.activatedpadding || "0",
          margin: div.activatedmargin || div.margin || "0px",
          marginTop: div.activatedmarginTop || div.activatedmargin || "0px",
          marginRight: div.activatedmarginRight || div.activatedmargin || "0px",
          marginBottom:
            div.activatedmarginBottom || div.activatedmargin || "0px",
          marginLeft: div.activatedmarginLeft || div.activatedmargin || "0px",

          borderTop:
            div.activatedborderTop ||
            div.activatedborder ||
            div.border ||
            "none",
          borderRight:
            div.activatedborderRight ||
            div.activatedborder ||
            div.border ||
            "none",
          borderBottom:
            div.activatedborderBottom ||
            div.activatedborder ||
            div.border ||
            "none",
          borderLeft:
            div.activatedborderLeft ||
            div.activatedborder ||
            div.border ||
            "none",
          borderSapcing:
            div.activatedborderSpacing || div.borderSpacing || "0px",
          borderCollapse:
            div.activatedborderCollapse || div.borderCollapse || "0px",
          borderRadius: div.activatedborderRadius || div.borderRadius || "0",
          outline: div.activatedoutline || div.outline || "none",

          position: div.activatedposition || div.position || "relative",
          top: div.activatedtop || div.top || "auto",
          right: div.activatedright || div.right || "auto",
          bottom: div.activatedbottom || div.bottom || "auto",
          left: div.activatedleft || div.left || "auto",
          zIndex: div.activatedzIndex || div.zIndex || "auto",

          boxShadow: div.activatedboxShadow || div.boxShadow || "none",
          opacity: div.activatedOpacity || div.opacity || 1,
          cursor: div.activatedcursor || div.cursor || "default",
          visibility: div.activatedvisibility || "visible",
        }
      : {};

  const divStyle = {
    width: div.width || "20%",
    height: div.height || "30%",

    paddingRight: div.paddingRight || div.padding || "0px",
    paddingBottom: div.paddingBottom || div.padding || "0px",
    paddingLeft: div.paddingLeft || div.padding || "0px",
    marginTop: div.marginTop || div.margin || "0px",
    marginRight: div.marginRight || div.margin || "0px",
    marginBottom: div.marginBottom || div.margin || "0px",
    marginLeft: div.marginLeft || div.margin || "0px",

    borderTop: div.borderTop || div.border || "none",
    borderRight: div.borderRight || div.border || "none",
    borderBottom: div.borderBottom || div.border || "none",
    borderLeft: div.borderLeft || div.border || "none",
    borderSapcing: div.borderSpacing || "0px",
    borderCollapse: div.borderCollapse || "0px",
    borderRadius: div.borderRadius || "0",
    outline: div.outline || "none",

    position: div.position || "static",
    top: div.top || "auto",
    right: div.right || "auto",
    bottom: div.bottom || "auto",
    left: div.left || "auto",
    zIndex: div.zIndex || "auto",

    boxShadow: div.boxShadow || "none",
    opacity: div.opacity || "1",
    boxSizing: div.boxSizing || "border-box",
    display: div.display || "block",
    visibility: div.visibility || "visible",
    cursor: div.cursor || "auto",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  return (
    <iframe
      src={div.sourceIframe || "https://nexgensites.netlify.app/about"}
      title={div.tilteForFrame || "NexGen Web Builder"}
      frameBorder="0"
      className="Main_Division"
      ref={divisionRef}
      style={divStyle}
      onMouseEnter={() => setIsDivHovered(true)}
      onMouseLeave={() => setIsDivHovered(false)}
      onFocus={() => setIsDivFocused(true)}
      onBlur={() => setIsDivFocused(false)}
      onMouseDown={() => setIsDivActive(true)}
      onMouseUp={() => setIsDivActive(false)}
      tabIndex={0}
    ></iframe>
  );
};

export default IframeComponent;
